import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import instance from "../../../config/Config";

export const getSeoContent = createAsyncThunk("getSeoContent", async () => {
  try {
    const response = await instance.get(`/remark/seo/fetch-seo-content`);

    return response.data;
  } catch (error) {
    throw error;
  }
});
export const getSeoMeta = createAsyncThunk("getSeoMeta", async () => {
  try {
    const response = await instance.get(`/remark/seo/fetch-seo-meta`);

    return response.data;
  } catch (error) {
    throw error;
  }
});
export const getPageList = createAsyncThunk("getPageList", async (listSeo) => {
  try {
    const response = await instance.get(`/remark/seo/fetch-seo-pages`);
    return response.data;
  } catch (error) {
    throw error;
  }
});
export const getSeoPageTags = createAsyncThunk("getSeoPageTags", async (id) => {
  try {
  
    const response = await instance.get(`/remark/seo/fetch-single-content?id=${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
});

export const addSeoPage = createAsyncThunk(
  "addSeoPage",
  async (body, { rejectWithValue }) => {
    try {
      const response = await instance.post("/remark/seo/create-seo-page", body);

      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export const addSeoMetaPage = createAsyncThunk(
  "addSeoMetaPage",
  async (body, { rejectWithValue }) => {
    try {

      const response = await instance.post("/remark/seo/create-seo-meta", body);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export const addSeoMetaTag = createAsyncThunk(
  "addSeoMetaTag",
  async (body, { rejectWithValue }) => {
    try {

      const response = await instance.post("/remark/seo/create-seo-content", body);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);


export const SeoContentSlice = createSlice({
  name: "SeoContentSlice",
  initialState: {
    data: null,
    loading: false,
    error: null,
    response: null,
    pageList: null,
    metaData: [],
    tagList: [],


  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getSeoContent.pending, (state) => {
      state.loading = true;
      state.data = null;
    });
    builder.addCase(getSeoContent.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload?.data;
    });
    builder.addCase(getSeoContent.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload;
    });

    builder.addCase(getSeoMeta.pending, (state) => {
      state.loading = true;
      state.metaData = null;
    });
    builder.addCase(getSeoMeta.fulfilled, (state, action) => {
      state.loading = false;
      state.metaData = action.payload?.data;
    });
    builder.addCase(getSeoMeta.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload;
    });

    builder.addCase(getSeoPageTags.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSeoPageTags.fulfilled, (state, action) => {
      state.loading = false;
      state.tagList = action.payload?.data;
    });
    builder.addCase(getSeoPageTags.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload;
    });

    builder.addCase(addSeoMetaPage.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(addSeoMetaPage.fulfilled, (state, action) => {
      state.loading = false;
      state.response = action?.payload;

    });

    builder.addCase(addSeoMetaPage.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload;
    });

    builder.addCase(getPageList.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getPageList.fulfilled, (state, action) => {
      state.loading = false;
      state.pageList = action?.payload;
    });
    builder.addCase(getPageList.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload;
    });

    builder.addCase(addSeoPage.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(addSeoPage.fulfilled, (state, action) => {
      state.loading = false;
      state.response = action?.payload;
    });
    builder.addCase(addSeoPage.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload;
    });

    builder.addCase(addSeoMetaTag.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(addSeoMetaTag.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action?.payload;
    });
    builder.addCase(addSeoMetaTag.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload;
    });

  },
});

export default SeoContentSlice.reducer;
